import { render, staticRenderFns } from "./workshop-hero.vue?vue&type=template&id=26165f7e&scoped=true&"
import script from "./workshop-hero.vue?vue&type=script&lang=js&"
export * from "./workshop-hero.vue?vue&type=script&lang=js&"
import style0 from "./workshop-hero.vue?vue&type=style&index=0&id=26165f7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26165f7e",
  null
  
)

export default component.exports